import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import SectorSolutionsSlider from "../sliders/SectorSolutionsSlider";
import { OurSolIcon } from "../../assets/img";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import "./SectorSolutions.css";

const SectorSolutions = React.memo(({ title, description, sliderData }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const handleNavigation = () => {
		navigate("/solutions");
	};

	return (
		<section className='lg:pt-40 pt-24 md:px-12 px-4 md:pb-32 pb-24 sectorSolutions bg-section_bg'>
			<div className='curve-top'></div>
			<div>
				<div className='flex justify-center items-center gap-2 mb-4'>
					<img
						loading='lazy'
						className='rotate-animate'
						src={OurSolIcon}
						alt='Solution Icon'
					/>
					<h3 className='text-second_color font-semibold md:text-4xl text-3xl'>
						{title}
					</h3>
				</div>
				<Fade direction='up' triggerOnce={true}>
					<p className='md:text-2xl text-xl md:w-[90%] w-full m-auto font-medium text-slate-950 text-center mb-3'>
						{description}
					</p>
				</Fade>
				<SectorSolutionsSlider data={sliderData} />
				<div className='w-max m-auto z-10 relative'>
					<Fade
						direction={i18n.language === "ar" ? "right" : "left"}
						triggerOnce={true}>
						<button
							className={`${
								i18n.language === "en" ? "default-btn-ltr" : "default-btn-rtl"
							} default-btn main-color-btn`}
							onClick={handleNavigation}>
							{t("more about solutions")}
							{i18n.language === "ar" ? (
								<HiOutlineArrowSmLeft className='rtl' />
							) : (
								<HiOutlineArrowSmRight className='ltr' />
							)}
							<span></span>
						</button>
					</Fade>
				</div>
			</div>
			<div className='curve-bottom'></div>
		</section>
	);
});

export default SectorSolutions;
